// extracted by mini-css-extract-plugin
module.exports = {"container":"_93444fe79c--container--mtPSn","video-container":"_93444fe79c--video-container--yfNUh","icon":"_93444fe79c--icon--HPXDj"};